import { render, staticRenderFns } from "./Voz.vue?vue&type=template&id=162e622c"
import script from "./Voz.vue?vue&type=script&lang=ts"
export * from "./Voz.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports